/**
 * Helpers purs pour le traitement WebSocket `notification:new` (BL-0435).
 * Filtre org (null/absent = globale) + idempotence par id.
 */

/**
 * Accepte une notification WS si elle est globale (org absente) ou liée à l'org courante.
 * Ignore si organizationId est défini et différent de l'org de session.
 */
export function u2000ShouldAcceptNotificationForOrg(
  notificationOrganizationId: string | null | undefined,
  currentOrganizationId: string | null | undefined,
): boolean {
  if (notificationOrganizationId == null || notificationOrganizationId === '') {
    return true;
  }
  if (currentOrganizationId == null || currentOrganizationId === '') {
    return true;
  }
  return notificationOrganizationId === currentOrganizationId;
}

/**
 * Indique si l'id est nouveau (pas encore dans la liste ni dans les ids déjà vus).
 * Un second message WS avec le même id ne doit pas faire ++ sur le badge.
 */
export function u2000IsNewNotificationId(
  id: string,
  existingIds: ReadonlySet<string> | readonly string[],
  seenIds: ReadonlySet<string>,
): boolean {
  if (seenIds.has(id)) {
    return false;
  }
  if (existingIds instanceof Set) {
    return !existingIds.has(id);
  }
  return !existingIds.includes(id);
}
